// annoucement bar
// $(document).ready(function() {
  $('.slider_topbar').slick({
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 6000,
    speed: 800,
    slidesToShow: 1,
    cssEase: 'ease-in-out',
    pauseOnHover: false,
    pauseOnFocus: false
  });
// });
$('.sliderimgsldrs').slick({
  dots: true,
  infinite: true,
  autoplay: false,
  autoplaySpeed: 5000,
  speed: 300,
  arrows:true,
  slidesToShow: 1,
  prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0514/9474/8358/files/left-arrow_bcd88d49-dd7f-4156-a0d4-40b25888a614.png?v=1744973384"></button>',
  nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0514/9474/8358/files/right-arrow_ff5c562c-031a-4e50-871a-630b6febb43c.png?v=1744973383"></button>'
});
function initSlick() {
if ($(window).width() <= 844) {
  if (!$('.fiveboxcont').hasClass('slick-initialized')) {
      $('.fiveboxcont').slick({
          slidesToShow: 1, // One full slide with the next half visible
          slidesToScroll: 1,
          infinite: false,
          arrows: true,
          centerMode: false,
          centerPadding: '0%',
          dots: true,
          prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0514/9474/8358/files/left-arrow_244c7750-c959-444c-9eec-e02288cebad8.png?v=1743688827"></button>',
          nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0514/9474/8358/files/right-arrow.png?v=1743688828"></button>'
      });
  }
    $('.blockbxsliderslck').slick({
        slidesToShow: 1, // One full slide with the next half visible
          slidesToScroll: 1,
          infinite: false,
          arrows: true,
          centerMode: false,
          centerPadding: '0%',
          dots: true,
          prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0514/9474/8358/files/left-arrow_244c7750-c959-444c-9eec-e02288cebad8.png?v=1743688827"></button>',
          nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0514/9474/8358/files/right-arrow.png?v=1743688828"></button>'
    });
} else {
  if ($('.fiveboxcont').hasClass('slick-initialized')) {
      $('.fiveboxcont').slick('unslick');
  }
    $('.blockbxsliderslck').slick({
      dots: true,
      arrows: true,
      infinite: true,
      autoplay: false,
      speed: 300,
      slidesToShow: 4,
      prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0514/9474/8358/files/left-arrow_244c7750-c959-444c-9eec-e02288cebad8.png?v=1743688827"></button>',
      nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0514/9474/8358/files/right-arrow.png?v=1743688828"></button>'
  });
  }
}

initSlick();
$(window).on('resize', initSlick);

// custom banner slider
$('.location_slider').slick({
  dots: true,
  infinite: true,
  autoplay: false,
  arrows: true,
  autoplaySpeed: 7000,
  speed: 300,
  slidesToShow: 1,
  adaptiveHeight:false,
  swipe: false,
  variableWidth:false
});

$(document).ready(function() {
  $('.lookbook-img_slider').slick({
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 5000,
    speed: 300,
    slidesToShow: 1
  });
  $('.lookbook-img_slider .slick-slide').click(function() {
    var slider = $(this).closest('.lookbook-img_slider');
    slider.slick('slickNext');
  });
  $('.tt-lookbook-slider').slick({
      dots: false,
      infinite: false,
      autoplay: false,
      autoplaySpeed: 5000,
      speed: 300,
      slidesToShow: 4
    });
   
  $('.lookbook-img_slide').on('init afterChange', function (event, slick, currentSlide) {
  var index = currentSlide || 0;
  $('.slick-slide').removeClass('is-active');
  $('.slick-slide[data-slick-index="' + index + '"]').addClass('is-active');
});
});

/*$(".tt-hotspot").mouseleave(function(){

 
   let mydata = document.querySelector('.tt-hotspot-content');
let existingStyle = mydata.style.cssText;
mydata.style.cssText = existingStyle + " opacity: 0;";

});*/

// document.querySelectorAll(".tt-hotspot").forEach(function(hotspot) {
//   hotspot.addEventListener("mouseleave", function() {
// //   $('.tt-hotspot').removeClass('active');
//     let mydata = document.querySelector(".tt-lookbook-popup");
//     let existingStyle = mydata.style.cssText;
   
//    mydata.style.cssText = existingStyle + " opacity: 0;";
//   });
// });


var  ttwindowWidths = window.innerWidth || $window.width();
 if(ttwindowWidths <= 789){
          document.querySelectorAll(".tt-hotspotjgh").forEach(function(hotspot) {
  hotspot.addEventListener("click", function(e) {
    var $this = $(this),
        lurl = '/products/'+$(this).attr('data-prhandle')+'?view=getproductlookbook';
    var params = {
      type: "get",
      url: lurl,
      success: function(data) {
        $this.find('.tt-hotspot-content').empty();
       const parser = new DOMParser();
      const html = parser.parseFromString(data, 'text/html');        
        let MyContent = html.querySelector('.tt-title');
        $this.find('.tt-hotspot-content').append(MyContent);
      }
    };
 jQuery.ajax(params);
  });
});
        }else{
   document.querySelectorAll(".tt-hotspotjgh").forEach(function(hotspot) {
  hotspot.addEventListener("mouseenter", function(e) {
    var $this = $(this),
        lurl = '/products/'+$(this).attr('data-prhandle')+'?view=getproductlookbook';
    console.log(lurl);
    var params = {
      type: "get",
      url: lurl,
      success: function(data) {
        $this.find('.tt-hotspot-content').empty();
       const parser = new DOMParser();
      const html = parser.parseFromString(data, 'text/html');        
        let MyContent = html.querySelector('.tt-title');
        $this.find('.tt-hotspot-content').append(MyContent);
        //setTimeout(showMessage(this, e), 200);
      }
    };
 jQuery.ajax(params);
  });
});
        }
$(".lookbook-img_slider").on("afterChange", function (){
 // $('.tt-hotspotjgh').addClass('hide');
   var dataId = $(this).find('.slick-active').attr("data-slick-index");  
  dataId =parseInt(dataId)+1
  var mm = parseInt(dataId)-1
  console.log(mm);
   $(this).closest('.tt-lookbook').find('.tt-hotspotjgh').removeClass('active');

 $(this).closest('.tt-lookbook').find('.tt-hotspotjgh[data-index='+dataId+']').addClass('active');

});
$(".share-buttons_inner_wrapper .share_btn").click(function(){
  $(".share_icons_home").addClass("open-icons");
});
$(".icons_inner-box .close_btn").click(function(){
  $(".share_icons_home").removeClass("open-icons");
});
$('body').on('click','.language-change',function(){
  var lang = $(this).attr('data-lang');
  if(lang == 'FR'){
    $('.ht-tms-dropdown__flag-on[data-value=fr]').trigger('click');
  }else if(lang == 'DE'){
      $('.ht-tms-dropdown__flag-on[data-value=de]').trigger('click');
  }else if(lang == 'IT'){
      $('.ht-tms-dropdown__flag-on[data-value=it]').trigger('click');
  }else if(lang == 'ES'){
      $('.ht-tms-dropdown__flag-on[data-value=es]').trigger('click');
  }else if(lang == 'EN'){
      $('.ht-tms-dropdown__flag-on[data-value=en]').trigger('click');
  }
});
setTimeout(function(){
   var currentlang = $('html').attr('lang');
    if(currentlang == 'en'){
      $('.language-change[data-lang=EN]').addClass('hide');
    } else if(currentlang == 'fr'){
      $('.language-change[data-lang=FR]').addClass('hide');
    } else if(currentlang == 'it'){
      $('.language-change[data-lang=IT]').addClass('hide');
    } else if(currentlang == 'de'){
      $('.language-change[data-lang=DE]').addClass('hide');
    } else if(currentlang == 'es'){
      $('.language-change[data-lang=ES]').addClass('hide');
  }
},5000);

$(document).on('click','.optimizeslide.butstovemeasr .zoomfornew',function(){
  var getimg = $(this).siblings('.desktop_img').attr('src');
  $('.optimizeslide.butstovemeasr #popupImage').attr('src',getimg);
  $('.optimizeslide.butstovemeasr .openfullbx').show();
});
$(document).on('click','.optimizeslide.butstovemeasr .openclose',function(){
  $(this).parent('.openfullbx').hide();
});
const windowWidth = window.innerWidth;
console.log(windowWidth);
